"use client"
import { useScript } from "@/hooks/useScript";
import React, {useEffect} from "react";
import { kickerTippspielJs, pwaTippspielPath, signInPath } from "@/utils/urlHelper";
import Link from "next/link";
import Image from "@/app/pwa/components/Image";
import Teaser from "@/assets/tippspiel/tippspiel-log-in-teaser.webp";
import { Card } from "@/app/pwa/components/Card";
import Container from "@/app/pwa/components/Container";
import { GenericSkeletonLoader } from "@/app/pwa/loading";


declare global {
  interface Window {
    TippApp: any;
  }
}

export function Tippspiel({ clubId, jwtToken }: { clubId: string, jwtToken: string | undefined }) {
  const [loaded, error] = useScript(kickerTippspielJs(), "tippspiel-js");  
  const [colorScheme, setColorScheme] = React.useState('light');

  useEffect(() => {
    if (loaded && jwtToken) {
      setColorScheme(window.matchMedia("(prefers-color-scheme: dark)").matches ? 'dark' : 'light');
      const data = {
        prefix: '',
        rootId: 'tippspiel',
        jwtToken: jwtToken,
      }
      window.TippApp.startVereinsheimEmbed(data)
      // window.TippApp.startEmbed(data)
    }
    if (error) {
      console.error('Script failed to load');
    }
  }, [loaded, error, setColorScheme]);

  return (
    <>
      { jwtToken &&
        <div className="lg:page-pl lg:page-pr">
          <Card className="max-w-basic-page lg:p-1" p={false}>
            <div id="tippspiel" className={`kicker-tippspiel ${colorScheme}`}>

              <div className="min-h-[80dvh] flex items-center justify-center">
                <div className="loading-spinner "></div>

              </div>

            </div>

          </Card>
          <div className="lg:h-8"></div>
        </div>
      }
      {!jwtToken &&
      <Container className="mt-section lg:mt-0">
        <Card p={false} className="overflow-hidden">
          <Link
              href={signInPath(pwaTippspielPath(clubId.replaceAll("ama", "")))}
              className="flex flex-col"
              >
            <div className="p-4 bg-[#4161a7] text-white-forced">
      
                <div className="font-bold text-center">
                  Anmelden und lostippen!
                </div>
            </div>
            <Image src={Teaser.src} alt="" width={1000} height={563} />
          </Link>

        </Card>
      </Container>}
    </>
  );
}
